var map = {
	"./": "./src/plugin/index.js",
	"./backgroundPlugin/backgroundPlugin": "./src/plugin/backgroundPlugin/backgroundPlugin.js",
	"./backgroundPlugin/backgroundPlugin.js": "./src/plugin/backgroundPlugin/backgroundPlugin.js",
	"./backgroundPlugin/environmentBanner": "./src/plugin/backgroundPlugin/environmentBanner.vue",
	"./backgroundPlugin/environmentBanner.vue": "./src/plugin/backgroundPlugin/environmentBanner.vue",
	"./error-store": "./src/plugin/error-store/index.js",
	"./error-store/": "./src/plugin/error-store/index.js",
	"./error-store/index": "./src/plugin/error-store/index.js",
	"./error-store/index.js": "./src/plugin/error-store/index.js",
	"./index": "./src/plugin/index.js",
	"./index.js": "./src/plugin/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/plugin sync recursive ^\\.\\/.*$";